import type { PresenceActivity } from '@atlaskit/editor-common/collab';

import type { Agent } from '@atlassian/conversation-assistant-service/types';

import type { AgentIconType } from '@confluence/agent-user-dual-avatar/entry-points/agentIconType.ts';

type AgentPresencePermit = {
	isPermittedToEdit?: boolean;
	// Sent as true by the service when a prompt from Rovo Chat records view presence. On the view
	// route this is the only permit an agent has, so it is what decides whether it renders at all.
	isPermittedToView?: boolean;
};

export type AgentPresenceStatus = 'active' | 'inactive' | 'expired';

export type AgentWithPresence = Agent & {
	actingUserId?: string;
	agentIcon?: AgentIconType;
	agentType?: string;
	avatarUrl?: string;
	isExternalAgentFallback?: boolean;
	presenceStatus?: AgentPresenceStatus;
	permit?: AgentPresencePermit;
	presenceId?: string;
	presenceActivity?: PresenceActivity;
	lastActive?: number;
};

export const getAgentPresenceKey = ({
	id,
	actingUserId,
	includeActingUser = false,
}: Pick<AgentWithPresence, 'id' | 'actingUserId'> & {
	includeActingUser?: boolean;
}): string => (includeActingUser && actingUserId ? `${id}:${actingUserId}` : id);
